
import { Component, Mixins } from 'vue-property-decorator'

import { DialogMixin } from '@/mixins'

/**
 * 画面仕様書
 *
 * 機能名　  : 共通機能
 * 画面ＩＤ  : MLC-0100
 * 画面名　  : エラーダイアログ
 * 概要　　  : エラーメッセージを表示するダイアログ
 */
@Component
export default class MLC_0100 extends Mixins(DialogMixin) {
  constructor() {
    super()
  }
}
